/**
 * Enum value maps matching the C# domain enums serialised as integers.
 * Severity:    0=Low 1=Medium 2=High 3=Critical
 * IssueStatus: 0=New 1=Acknowledged 2=InProgress 3=Resolved 4=Ignored 5=Escalated
 * Category:    0=Gate 1=Pool 2=Safety 3=Parking 4=Maintenance 5=Landscape 6=Other
 * SourceKind:  0=Portal 1=FacebookGroup 2=FacebookPage 3=Sms 4=Email
 */
export const SEVERITY_LABEL = {
    0: 'Low',
    1: 'Medium',
    2: 'High',
    3: 'Critical',
};
export const SEVERITY_BADGE = {
    0: 'low',
    1: 'medium',
    2: 'high',
    3: 'critical',
};
/** Tailwind left-border class for mobile card severity stripe. */
export const SEVERITY_BORDER_COLOR = {
    0: 'bg-navy-500',
    1: 'bg-amber-500',
    2: 'bg-orange-500',
    3: 'bg-red-600',
};
export const STATUS_LABEL = {
    0: 'New',
    1: 'Acknowledged',
    2: 'In Progress',
    3: 'Resolved',
    4: 'Ignored',
    5: 'Escalated',
};
export const STATUS_BADGE = {
    0: 'new',
    1: 'info',
    2: 'progress',
    3: 'resolved',
    4: 'soft',
    5: 'critical',
};
export const CATEGORY_LABEL = {
    0: 'Gate',
    1: 'Pool',
    2: 'Safety',
    3: 'Parking',
    4: 'Maintenance',
    5: 'Landscape',
    6: 'Other',
};
export const SOURCE_LABEL = {
    0: 'Portal',
    1: 'Facebook Group',
    2: 'Facebook Page',
    3: 'SMS',
    4: 'Email',
};
